import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";

class LegacyIndiamart extends React.Component {

    render() {
        return (
            <>
                <div className={'cursor-pointer ml-2 mb-2'} onClick={(e) => {this.props.onBackAction(e)}}>
                    <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                </div>
                <LegacyFrame withHeader={false} pageTitle={"Indiamart"} formname={"immapping"} customClass={"field-customization-container"} />
            </>

        );
    }
}

export default LegacyIndiamart;
